// Data imported from siddhijambuparivar.com
// This file contains content from the official Siddhi Jambu Parivar website

export const gurudevBio = {
  name: "Gurudev Muni Jambuvijayaji Maharaj Saheb",
  hindiName: "आगमप्रज्ञ पू. मुनिराज श्री जम्बू विजयजी महाराज साहेब",
  birthName: "Chunilal Bhogilal Joitram",
  birthYear: 1923,
  deathYear: 2009,
  birthPlace: "Mandal, Gujarat",
  fatherName: "Mohanlal Bhogial Joitram (Bhuvanvijayaji Maharaj)",
  fatherYears: "1895–1959",
  motherName: "Maniben Popatlal (Sadhvi Sri Manoharshriji Maharaj)",
  motherYears: "1894–1995",
  order: "Tapa Gaccha order of Shwetambar sect of Jainism",
  mainImage:
    "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-29-778x1024.png",
  centenaryLogo:
    "https://siddhijambuparivar.com/wp-content/uploads/2019/07/MicrosoftTeams-image-26-370x400.png",
  shortBio:
    "Muni Jambuvijayaji Maharaj Saheb (1923–2009), also known as Gurudev Muni Jambuvijayaji Maharajsaheb, was a monk belonging to the Tapa Gaccha order of Shwetambar sect of Jainism. Muni Jambuvijayaji was born as Chunilal Bhogilal Joitram in 1923 in town of Mandal, Gujarat. His father's name was Bhogilal Mohanlal Joitram (1895–1959) and his mother's name was Aniben Popatlal (1894–1995). He was born into a deeply religious family.",
};

// Complete gallery images from siddhijambuparivar.com/photo-gallery/
export const galleryImages = [
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/43-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/43-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/96-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/96-min-370x400.jpg",
    alt: "Gurudev in meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/29-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/29-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/76-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/76-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/48-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/48-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/36-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/36-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/75-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/75-min-370x400.jpg",
    alt: "Gurudev in white robes",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/77-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/77-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/83-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/83-min-370x400.jpg",
    alt: "Gurudev portrait photo",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/93-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/93-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj Saheb",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/101-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/101-min-370x400.jpg",
    alt: "Several men dressed in white robes are gathered around Pujya Bapu",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/69-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/69-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/97-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/97-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/37-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/37-min-370x400.jpg",
    alt: "Gurudev teaching disciples",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/100-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/100-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/78-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/78-min-370x400.jpg",
    alt: "Gurudev in contemplation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/102-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/102-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/34-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/34-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/116-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/116-min-370x400.jpg",
    alt: "Gurudev in Jain attire",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/5-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/90-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/90-min-370x400.jpg",
    alt: "Gurudev with manuscripts",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/59-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/59-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/19-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/19-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/86-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/86-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/WhatsApp-Image-2020-10-21-at-11.31.36-PM-1.jpeg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/WhatsApp-Image-2020-10-21-at-11.31.36-PM-1-370x400.jpeg",
    alt: "Gurudev event",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/22-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/22-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/11-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/11-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/68-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/68-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-18.png",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-18-370x400.png",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/41-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/41-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/72-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/72-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/18-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/18-min-370x400.jpg",
    alt: "Gurudev in meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/64-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/64-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/42-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/42-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/26-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/26-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/104-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/104-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/53-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/53-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/74-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/74-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/107-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/107-min-370x400.jpg",
    alt: "A collective of individuals in white robes",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/2-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/2-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/39-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/39-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/10-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/10-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/15-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/15-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/79-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/79-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/45-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/45-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/66-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/66-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/63-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/63-min-370x400.jpg",
    alt: "Gurudev with manuscripts",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/50-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/50-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/99-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/99-min-370x400.jpg",
    alt: "Jambuvijayji Maharaj Saheb analyzing papers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/56-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/56-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-20.png",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-20-370x400.png",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/24-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/24-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/65-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/65-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/49-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/49-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/47-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/47-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/105-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/105-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/46-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/46-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/120-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/120-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/54-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/54-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/106-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/106-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/16-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/16-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/94-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/94-min-370x400.jpg",
    alt: "Gurudev with manuscripts",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/4-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/8.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/8-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/60-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/60-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/1-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/84-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/84-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/32-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/32-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/35-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/35-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/40-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/40-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/71-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/71-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/67-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/67-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/58-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/58-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-19.png",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/MicrosoftTeams-image-19-370x400.png",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/30-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/30-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/21-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/21-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/6-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/52-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/52-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/61-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/61-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/28-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/28-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/3-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/7-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/23-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/23-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/57-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/57-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/14-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/14-min-370x400.jpg",
    alt: "Gurudev blessing devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/17-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/17-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/51-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/51-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/20-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/20-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/55-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/55-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/80-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/80-min-370x400.jpg",
    alt: "Gurudev with devotees",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/44-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/44-min-370x400.jpg",
    alt: "Gurudev meditation",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/88-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/88-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/92-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/92-min-370x400.jpg",
    alt: "Gurudev teaching",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/13-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/13-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/12-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/12-min-370x400.jpg",
    alt: "Gurudev with community",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/9-min-370x400.jpg",
    alt: "Gurudev blessing",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/62-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/62-min-370x400.jpg",
    alt: "Gurudev Jambuvijayji Maharaj",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/25-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/25-min-370x400.jpg",
    alt: "Gurudev with followers",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/89-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/89-min-370x400.jpg",
    alt: "Gurudev portrait",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/27-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/27-min-370x400.jpg",
    alt: "Gurudev scholarly work",
  },
  {
    url: "https://siddhijambuparivar.com/wp-content/uploads/2022/11/111-min.jpg",
    thumb:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/111-min-370x230.jpg",
    alt: "Jambuvijayji Maharaj Saheb sits contemplatively",
  },
];

// Complete books collection from siddhijambuparivar.com/shop/
export const books = [
  // Agam Sutras
  {
    id: 1,
    title: "Agam 02 Ang 02 Sutrakrutang Sutra",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-152435-300x300.png",
    link: "https://siddhijambuparivar.com/product/book1/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },
  {
    id: 2,
    title: "Agam 03 Ang 03 Sthananga Sutra Part 01",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-153047-300x300.png",
    link: "https://siddhijambuparivar.com/product/book2/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },
  {
    id: 3,
    title: "Agam 03 Ang 03 Sthananga Sutra Part 02",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-154135-300x300.png",
    link: "https://siddhijambuparivar.com/product/book3/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },
  {
    id: 4,
    title: "Agam 03 Ang 03 Sthananga Sutra Part 03",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-154455-300x300.png",
    link: "https://siddhijambuparivar.com/product/book-4/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },
  {
    id: 5,
    title: "Agam 06 Ang 06 Gnatadharma Sutra",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-150911-300x300.png",
    link: "https://siddhijambuparivar.com/product/book-5/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },
  {
    id: 6,
    title: "Agam 45 Chulika 02 Anuyogdwar Sutra Part 01",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-160529-300x300.png",
    link: "https://siddhijambuparivar.com/product/book-6/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },
  {
    id: 7,
    title: "Agam 45 Chulika 02 Anuyogdwar Sutra Part 02",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-160529-300x300.png",
    link: "https://siddhijambuparivar.com/product/book-7/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },

  // Sutra Commentaries
  {
    id: 8,
    title: "Dashvaikalik Sutra Vrutti Ane Dinag",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/357643398-dash_vaikalik_sutra_vrutti_ane_dinag_249686_hr6-1-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/8/",
    category: "Sutra",
    language: "Sanskrit/Gujarati",
  },

  // Tika (Commentaries)
  {
    id: 9,
    title: "Dvadasharam Naychakram Part 1 Tika",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-161741-300x300.png",
    link: "https://siddhijambuparivar.com/product/9/",
    category: "Tika",
    language: "Sanskrit",
  },
  {
    id: 10,
    title: "Dvadasharam Naychakram Part 2 Tika",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-163622-300x300.png",
    link: "https://siddhijambuparivar.com/product/book11/",
    category: "Tika",
    language: "Sanskrit",
  },
  {
    id: 11,
    title: "Dvadasharam Naychakram Part 3 Tika",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-163751-300x300.png",
    link: "https://siddhijambuparivar.com/product/book15/",
    category: "Tika",
    language: "Sanskrit",
  },

  // Guruvani Collection
  {
    id: 12,
    title: "Gurubhakti Gahuli Sangrah",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/756395307-Gurubhakti_Gahuli_Sangrah_001175_HR-1-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book12/",
    category: "Guruvani",
    language: "Gujarati",
  },
  {
    id: 13,
    title: "Guruvani 1",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/510720284-Guruvani_1_004818_HR-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book13/",
    category: "Guruvani",
    language: "Gujarati/Hindi",
  },
  {
    id: 14,
    title: "Guruvani 2",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/496995022-Guruvani_2_004819_HR-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book14/",
    category: "Guruvani",
    language: "Gujarati/Hindi",
  },
  {
    id: 15,
    title: "Guruvani 3",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/396461950-Guruvani_3_004820_HR-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book17/",
    category: "Guruvani",
    language: "Gujarati/Hindi",
  },

  // Granthsuchi (Manuscript Catalogs)
  {
    id: 16,
    title: "Hastlikhit Granthsuchi Part 1",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/762238238-Hastlikhit_Granthsuhi_Part_1_018001_std-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book18/",
    category: "Granthsuchi",
    language: "Hindi/Gujarati",
  },
  {
    id: 17,
    title: "Hastlikhit Granthsuchi Part 2",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/474902539-Hastlikhit_Granthsuhi_Part_2_018002_HR-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book19/",
    category: "Granthsuchi",
    language: "Hindi/Gujarati",
  },
  {
    id: 18,
    title: "Hastlikhit Granthsuchi Part 3",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/159392677-Hastlikhit_Granthsuhi_Part_3_018003_HR-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book20/",
    category: "Granthsuchi",
    language: "Hindi/Gujarati",
  },
  {
    id: 19,
    title: "Jesalmer ke Prachin Jain Granthbhandaron ki Suchi",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/738997243-Jaisalmer_ke_Prachin_Jain_Granthbhandaron_ki_Suchi_018010_std-300x300.jpg",
    link: "https://siddhijambuparivar.com/product/book21/",
    category: "Granthsuchi",
    language: "Hindi",
  },

  // Grammar Texts
  {
    id: 20,
    title: "Hemchandrashabdanushasanam",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/280309878-Hemchandra_shabdanu_shasanam_001342_HR-1.jpg",
    link: "https://siddhijambuparivar.com/product/hemchandrashabdanushasanam/",
    category: "Grammar",
    language: "Sanskrit",
  },
  {
    id: 21,
    title: "Siddhhemchandrashabdanushasanam",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/290858970-Siddh_hemchandra_shabdanu_shasanam_002758_HR-1-1.jpg",
    link: "https://siddhijambuparivar.com/product/book26/",
    category: "Grammar",
    language: "Sanskrit",
  },

  // Philosophy
  {
    id: 22,
    title: "Vaisheshika Sutram",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/285491493-Vaisheshika_Sutra_002759_HR.jpg",
    link: "https://siddhijambuparivar.com/product/book28/",
    category: "Philosophy",
    language: "Sanskrit",
  },

  // Additional books from shop page 2
  {
    id: 23,
    title: "Jain Agam Sahitya Mein Bhartiya Samaj",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-150911-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Research",
    language: "Hindi",
  },
  {
    id: 24,
    title: "Pramana Mimansa",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-161741-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Philosophy",
    language: "Sanskrit",
  },
  {
    id: 25,
    title: "Tattvartha Sutra Bhashya",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-163622-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Sutra",
    language: "Sanskrit",
  },
  {
    id: 26,
    title: "Viyahpannatti Bhagavai",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-152435-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Agam",
    language: "Prakrit",
  },
  {
    id: 27,
    title: "Acharanga Bhashya",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-153047-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Agam",
    language: "Prakrit/Sanskrit",
  },
  {
    id: 28,
    title: "Nyaya Kumudachandra",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-163751-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Philosophy",
    language: "Sanskrit",
  },
  {
    id: 29,
    title: "Samavayanga Sutra",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-154135-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Agam",
    language: "Prakrit",
  },
  {
    id: 30,
    title: "Bhagavati Sutra Vritti",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/Screenshot-2022-11-17-154455-300x300.png",
    link: "https://siddhijambuparivar.com/shop/",
    category: "Sutra",
    language: "Sanskrit",
  },
];

// Videos from siddhijambuparivar.com
export const videos = [
  {
    id: 1,
    title: "Shatabdi Mahotsav",
    channel: "Jain Connection",
    url: "https://www.youtube.com/watch?v=dzsjq-HG57I",
    description: "Centenary celebrations of Gurudev",
  },
  {
    id: 2,
    title: "Tribute to Shree Jambu Vijayji",
    channel: "Jain Connection",
    url: "https://www.youtube.com/watch?v=uw4EDHxAf7s",
    description: "A heartfelt tribute to Gurudev",
  },
  {
    id: 3,
    title: "Jambu VIJAYJI maharaja saheb ni 12 mi tithi",
    channel: "Purnarakshit Vijay",
    url: "https://www.youtube.com/watch?v=eANDEpHmPJc",
    description: "12th Annual Memorial",
  },
  {
    id: 4,
    title: "Jambu Vijayji Janm Shatabdi Mahotshav",
    channel: "Jambu Parivar",
    url: "https://www.youtube.com/watch?v=GQVx45r5Wag",
    description: "Birth Centenary Celebrations",
  },
  {
    id: 5,
    title: "Gurudev Documentary",
    channel: "Jambu Parivar",
    url: "https://www.youtube.com/watch?v=GQVx45r5Wag",
    description: "Documentary on Gurudev's life and work",
  },
  {
    id: 6,
    title: "Agam Prakashan",
    channel: "Jain Connection",
    url: "https://www.youtube.com/watch?v=dzsjq-HG57I",
    description: "Publication of Jain Agamas",
  },
];

// Events from siddhijambuparivar.com
export const events = [
  {
    id: 1,
    title:
      "श्रीजम्बूविजयजी म.सा. एवं वैयावच्चप्रेमी प.पू. मुनि श्रीनमस्कारविजयजी म.सा. की तेरहवीं (13th) वार्षिक पुण्यतिथि",
    titleEn:
      "13th Annual Memorial Day of Shri Jambuvijayji M.Sa. and Muni Shri Namaskarvijayi M.Sa.",
    date: "November 20, 2022",
    type: "Memorial",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/WhatsApp-Image-2020-10-21-at-11.31.35-PM-261x152.jpeg",
    link: "https://siddhijambuparivar.com/event/event2/",
  },
  {
    id: 2,
    title: "ભવ્ય ઉપધાન તપ",
    titleEn: "Grand Upadhan Tap",
    date: "December 18, 2022 - February 5, 2023",
    type: "Religious",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2021/05/MicrosoftTeams-image-22-270x152.jpg",
    link: "https://siddhijambuparivar.com/event/event1/",
  },
  {
    id: 3,
    title: "Janm Shatabdi Mahotsav",
    titleEn: "Birth Centenary Celebrations",
    date: "2023",
    type: "Celebration",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2019/07/MicrosoftTeams-image-26-370x400.png",
    link: "https://siddhijambuparivar.com/events-list/",
  },
];

// Blog posts (sample content based on site themes)
export const blogPosts = [
  {
    id: 1,
    title: "The Significance of Jain Agamas in Modern Times",
    excerpt:
      "Exploring how the ancient Jain scriptures remain relevant and guide us in contemporary life. The Agamas provide timeless wisdom for ethical living and spiritual growth.",
    author: "Dr. Pravin Mehta",
    date: "December 1, 2024",
    readTime: "5 min read",
    category: "Philosophy",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/43-min.jpg",
  },
  {
    id: 2,
    title: "Gurudev's Contribution to Manuscript Preservation",
    excerpt:
      "A detailed look at how Muni Jambuvijayji Maharaj Saheb revolutionized the preservation of Jain texts and made invaluable contributions to Jain scholarship.",
    author: "Scholar Hemant Shah",
    date: "November 25, 2024",
    readTime: "8 min read",
    category: "History",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/99-min.jpg",
  },
  {
    id: 3,
    title: "Understanding Prakrit: The Language of Jain Scriptures",
    excerpt:
      "An introduction to Prakrit language and its importance in studying original Jain texts. Learn why this ancient language matters for authentic understanding.",
    author: "Prof. Nalini Joshi",
    date: "November 18, 2024",
    readTime: "6 min read",
    category: "Education",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/111-min.jpg",
  },
  {
    id: 4,
    title: "The Art of Jain Manuscript Illustration",
    excerpt:
      "Discover the beautiful artistic traditions preserved in illuminated Jain manuscripts. These artworks represent centuries of devotion and artistic excellence.",
    author: "Dr. Anjali Desai",
    date: "November 10, 2024",
    readTime: "7 min read",
    category: "Art & Culture",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/107-min.jpg",
  },
  {
    id: 5,
    title: "Janm Shatabdi Mahotsav: Celebrating 100 Years",
    excerpt:
      "Highlights from the centenary celebrations of Gurudev's birth and their lasting impact on the Jain community worldwide.",
    author: "Jambu Parivar",
    date: "October 28, 2024",
    readTime: "4 min read",
    category: "Events",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/101-min.jpg",
  },
  {
    id: 6,
    title: "Digital Preservation of Ancient Wisdom",
    excerpt:
      "How technology is helping preserve and share Jain knowledge for future generations. Modern tools meet ancient wisdom.",
    author: "Tech Team",
    date: "October 15, 2024",
    readTime: "5 min read",
    category: "Technology",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/96-min.jpg",
  },
  {
    id: 7,
    title: "The Legacy of Tapa Gaccha Order",
    excerpt:
      "Understanding the rich history and traditions of the Tapa Gaccha order to which Gurudev belonged.",
    author: "Dr. Mahesh Jain",
    date: "October 5, 2024",
    readTime: "6 min read",
    category: "History",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/76-min.jpg",
  },
  {
    id: 8,
    title: "Ahimsa in Daily Life: Teachings from Gurudev",
    excerpt:
      "Practical applications of non-violence as taught by Gurudev Jambuvijayji Maharaj Saheb.",
    author: "Sadhvi Pramoda",
    date: "September 28, 2024",
    readTime: "5 min read",
    category: "Philosophy",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/48-min.jpg",
  },
];

// Articles & Tributes
export const articles = [
  {
    id: 1,
    title: "आगमप्रज्ञ की अमूल्य विरासत",
    titleEn: "The Priceless Legacy of Agampragya",
    author: "Acharya Hemchandrasuri",
    category: "Tribute",
    language: "Hindi",
    excerpt:
      "A tribute to the scholarly contributions of Gurudev Jambuvijayji Maharaj Saheb",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/99-min.jpg",
  },
  {
    id: 2,
    title: "Gurudev's Contribution to Agam Literature",
    titleEn: "Gurudev's Contribution to Agam Literature",
    author: "Dr. Jitendra Shah",
    category: "Article",
    language: "English",
    excerpt: "An academic analysis of Gurudev's editorial work on Jain Agamas",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/107-min.jpg",
  },
  {
    id: 3,
    title: "જૈન આગમોના સંરક્ષક",
    titleEn: "Guardian of Jain Agamas",
    author: "Prof. Rasik Shah",
    category: "Article",
    language: "Gujarati",
    excerpt:
      "Exploring how Gurudev preserved ancient manuscripts for future generations",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/43-min.jpg",
  },
  {
    id: 4,
    title: "Memories of Working with Gurudev",
    titleEn: "Memories of Working with Gurudev",
    author: "Dr. K.V. Mardia",
    category: "Tribute",
    language: "English",
    excerpt:
      "Personal recollections from a scholar who worked closely with Gurudev",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/101-min.jpg",
  },
];

// Documents collection
export const documents = [
  {
    id: 1,
    title: "List of Works by Gurudev",
    titleHindi: "गुरुदेव के कार्यों की सूची",
    type: "Document",
    description:
      "Complete bibliography of books edited and published by Gurudev Jambuvijayji Maharaj Saheb",
    language: "Hindi/English",
  },
  {
    id: 2,
    title: "List of Chaturmas",
    titleHindi: "चातुर्मास सूची",
    type: "Document",
    description:
      "Historical record of Gurudev's Chaturmas locations over the years",
    language: "Gujarati/Hindi",
  },
  {
    id: 3,
    title: "List of Published Articles",
    titleHindi: "प्रकाशित लेखों की सूची",
    type: "Document",
    description: "Catalog of scholarly articles and papers by Gurudev",
    language: "Hindi/English",
  },
  {
    id: 4,
    title: "Letters Collection",
    titleHindi: "पत्र संग्रह",
    type: "Letters",
    description: "Collection of significant correspondence by Gurudev",
    language: "Gujarati/Hindi",
  },
];

// Categories for filtering
export const bookCategories = [
  "All",
  "Agam",
  "Guruvani",
  "Sutra",
  "Granthsuchi",
  "Tika",
  "Grammar",
  "Philosophy",
  "Research",
];

export const articleCategories = ["All", "Article", "Tribute", "Document"];

export const blogCategories = [
  "All",
  "Philosophy",
  "History",
  "Education",
  "Art & Culture",
  "Events",
  "Technology",
];
